<template>

    <div>
        <settingsNav></settingsNav>

        <v-container>
            <v-layout row wrap>

                <v-flex xs12 sm12 mb-2>

                    <v-btn class="secondary white--text" @click.stop="openDialog(null)">
                        New Product
                        <v-icon class="white--text" right>add</v-icon>
                    </v-btn>

                </v-flex>

            </v-layout>

            <v-layout row wrap>

                <v-flex xs12 sm12>
                    <v-layout row>
                        <v-flex xs12>

                            <v-card>
                                <v-card-title>
                                    <v-card-title class="headline">
                                        Products
                                    </v-card-title>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                            v-model="search"
                                            append-icon="search"
                                            label="Search"
                                            single-line
                                            hide-details
                                            clearable
                                    ></v-text-field>
                                </v-card-title>

                                <v-data-table
                                        :headers="headers"
                                        :items="getProducts"
                                        :pagination.sync="pagination"
                                        :total-items=total
                                        class="elevation-0"
                                        :loading="loading"
                                        :rows-per-page-items="rowsPageItems"
                                >

                                    <template slot="headerCell" slot-scope="props">
                                        <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                            <span>
                                          {{ props.header.text }}
                                        </span>
                                        </v-tooltip>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                      <v-touch tag="tr"
                                               @doubletap="openDialog(props.item.id)"
                                               @dblclick="openDialog(props.item.id)">
                                            <td>{{ props.item.id }}</td>
                                            <td class="text-xs-left">{{ props.item.reference }}</td>
                                            <td class="text-xs-left">{{ props.item.manufacturer.name }}</td>
                                            <td class="text-xs-left">{{ props.item.created_at }}</td>
                                            <td class="text-xs-left">{{ props.item.updated_at }}</td>
                                            <td class="text-xs-right">
                                                <v-icon v-if="props.item.upload" color="secondary"
                                                        class="ma-1"
                                                >
                                                  fa-thin fa-square-check
                                                </v-icon>
                                                <v-icon v-else color="secondary"
                                                        class="ma-1"
                                                >
                                                  fa-regular fa-square
                                                </v-icon>
                                            </td>
                                      </v-touch>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-flex>

                    </v-layout>

                    <addProductDialog/>

                </v-flex>
            </v-layout>

        </v-container>
    </div>

</template>

<script>
    // Types
    import {
        Settings,
        ProductSettings
    } from '../../../store/namespace-helper'

    import addProductDialog from '../Products/AddProductDialog.vue'
    import settingsNav from '../../Shared/SettingsNav.vue'
    import {stateHelperMixin} from '../../../mixins/stateHelperMixin'
    import _ from 'lodash'

    export default {
      name: 'products',
      components: {
        addProductDialog,
        settingsNav
      },
      mixins: [stateHelperMixin],
      data () {
        return {
          isVisible: false,
          headers: [
                    {text: 'Product-ID', value: 'id'},
                    {text: 'Reference', value: 'reference'},
                    {text: 'Manufacturer', value: 'manufacturers.name', sortable: false},
                    {text: 'Created', value: 'created_at'},
                    {text: 'Updated', value: 'updated_at'},
                    {text: 'Upload', value: 'upload', sortable: false, align: 'right'}
          ],
          pagination: {},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [10, 25, 50, 100, 250]
        }
      },
      beforeDestroy () {
        this.resetStateBeforeLeaveRoute()
      },
      mounted () {
        this.loadProducts()
      },
      methods: {
            /*        visibilityChanged (isVisible, entry) {
                      if (this.isVisible !== isVisible) {
                        this.isVisible = isVisible
                        if (isVisible) {
                          console.log('Users tab visible, load data')
                          this.throttledLoadProducts()
                        }
                      }
                    }, */
        openDialog (val) {
          if (val !== null) {
            let item = this.getProducts.find(x => x.id === val)
            this.$store.dispatch(ProductSettings.actions.setSelectedProduct, item)
          }
          this.$store.dispatch(ProductSettings.actions.openCloseDialog)
        },
        loadProducts: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          this.$store.dispatch(ProductSettings.actions.loadProducts, query)
        },
        throttledLoadProducts: _.debounce(function () {
          this.loadProducts()
        }, 450)
      },
      computed: {
        getProducts () {
          console.log('ProductSettings.getters.products: ' + ProductSettings.getters.products)
          this.total = this.$store.getters[ProductSettings.getters.products].total
          return this.$store.getters[ProductSettings.getters.products].data
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadProducts()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadProducts()
          },
          deep: true
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Settings/Products/Products.vue